(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["selected-variant-title"] && !Shopify.designMode) return;
  try {
    class VariantInfoDescription extends HTMLElement {
    connectedCallback() {
      this.titleElement = this.querySelector('[data-selected-variant-title-value]');
      this.descriptionElement = this.querySelector('[data-selected-variant-description]');
      this.variants = this.getVariants();
      this.section = this.closest('.shopify-section') || this.closest('section') || document;
      this.priceElements = Array.from(
        this.section.querySelectorAll('[data-sc-wpt-retail-price]')
      );
      this.activeScope = this.section;
      this.productOriginalTitle = this.dataset.productTitle || '';

      this.handleChange = this.handleChange.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleVariantEvent = this.handleVariantEvent.bind(this);
      this.handleDomRefresh = this.handleDomRefresh.bind(this);

      this.patchHistoryEvents();

      document.addEventListener('change', this.handleChange);
      document.addEventListener('input', this.handleChange);
      document.addEventListener('click', this.handleClick);

      window.addEventListener('popstate', this.handleVariantEvent);
      window.addEventListener('variant-url-change', this.handleVariantEvent);

      document.addEventListener('variant:change', this.handleVariantEvent);
      document.addEventListener('variant:changed', this.handleVariantEvent);
      document.addEventListener('product:variant-change', this.handleVariantEvent);
      document.addEventListener('product:variant:change', this.handleVariantEvent);
      document.addEventListener('variant:update', this.handleVariantEvent);
      document.addEventListener('shopify:section:load', this.handleVariantEvent);

      this.observer = new MutationObserver(this.handleDomRefresh);
      this.observer.observe(this.section, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value', 'checked', 'selected', 'aria-pressed', 'data-selected'],
      });

      this.updateContent();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.handleChange);
      document.removeEventListener('input', this.handleChange);
      document.removeEventListener('click', this.handleClick);

      window.removeEventListener('popstate', this.handleVariantEvent);
      window.removeEventListener('variant-url-change', this.handleVariantEvent);

      document.removeEventListener('variant:change', this.handleVariantEvent);
      document.removeEventListener('variant:changed', this.handleVariantEvent);
      document.removeEventListener('product:variant-change', this.handleVariantEvent);
      document.removeEventListener('product:variant:change', this.handleVariantEvent);
      document.removeEventListener('variant:update', this.handleVariantEvent);
      document.removeEventListener('shopify:section:load', this.handleVariantEvent);

      if (this.observer) {
        this.observer.disconnect();
      }
    }

    patchHistoryEvents() {
      if (window.__variantInfoDescriptionHistoryPatched) return;

      window.__variantInfoDescriptionHistoryPatched = true;

      ['pushState', 'replaceState'].forEach((methodName) => {
        const originalMethod = history[methodName];

        history[methodName] = function patchedHistoryMethod() {
          const result = originalMethod.apply(this, arguments);
          window.dispatchEvent(new Event('variant-url-change'));
          return result;
        };
      });
    }

    getVariants() {
      const json = this.querySelector('[data-variant-info-json]');

      if (!json) return [];

      try {
        return JSON.parse(json.textContent);
      } catch (error) {
        console.warn('Variant JSON parse error:', error);
        return [];
      }
    }

    handleChange(event) {
      const target = event.target;

      if (!target) return;

      const isVariantInput = target.matches(
        'select, input[type="radio"], input[name="id"], select[name="id"], [name^="options"]'
      );

      if (!isVariantInput) return;

      const targetSection = target.closest('.shopify-section') || target.closest('section');

      if (targetSection && this.section !== document && targetSection !== this.section) {
        return;
      }

      this.activeScope = targetSection || this.section || document;
      this.scheduleUpdates();
    }

    handleClick(event) {
      const target = event.target?.closest(
        'select, input[type="radio"], label[for], button, [data-option-value], [data-variant-id], [data-option-value-id], [aria-pressed]'
      );

      if (!target) return;

      const targetSection = target.closest('.shopify-section') || target.closest('section');

      if (targetSection && this.section !== document && targetSection !== this.section) {
        return;
      }

      this.activeScope = targetSection || this.section || document;
      this.scheduleUpdates();
    }

    handleVariantEvent(event) {
      const variant = event.detail?.variant || event.detail?.selectedVariant || event.detail?.resource;

      if (variant?.id && this.variantExists(variant.id)) {
        this.renderVariant(String(variant.id));
        return;
      }

      this.scheduleUpdates();
    }

    handleDomRefresh(mutations) {
      const hasExternalChange = mutations.some((mutation) => !this.contains(mutation.target));

      if (!hasExternalChange) return;

      this.scheduleUpdates();
    }

    scheduleUpdates() {
      window.requestAnimationFrame(() => this.updateContent());
      window.setTimeout(() => this.updateContent(), 80);
      window.setTimeout(() => this.updateContent(), 180);
      window.setTimeout(() => this.updateContent(), 400);
      window.setTimeout(() => this.updateContent(), 800);
    }

    updateContent() {
      this.renderTitle();

      const variantId = this.getCurrentVariantId();

      if (variantId) {
        this.renderDescription(variantId);
        this.renderPrice(variantId);
      } else {
        this.hideDescription();
      }
    }

    getScope() {
      return this.activeScope || this.section || document;
    }

    getCurrentVariantId() {
      const variantIdFromSelectedOption = this.getVariantIdFromSelectedOption();

      if (variantIdFromSelectedOption) {
        return String(variantIdFromSelectedOption);
      }

      const variantFromOptions = this.getVariantFromSelectedOptions();

      if (variantFromOptions?.id) return String(variantFromOptions.id);

      const variantIdFromInput = this.getVariantIdFromInput();

      if (variantIdFromInput) return String(variantIdFromInput);

      const variantIdFromOptionValue = this.getVariantIdFromOptionValue();

      if (variantIdFromOptionValue) return String(variantIdFromOptionValue);

      const variantIdFromUrl = this.getVariantIdFromUrl();

      if (variantIdFromUrl) return String(variantIdFromUrl);

      return this.dataset.initialVariantId || '';
    }
    getVariantIdFromSelectedOption() {
  const scope = this.getScope();

  const selects = Array.from(
    scope.querySelectorAll(
      '.variant-option__select-wrapper select, variant-selects select, variant-picker select, select[name^="options"]'
    )
  );

  for (const select of selects) {
    const selectedOption = select.options[select.selectedIndex];

    if (!selectedOption) continue;

    const variantId = selectedOption.dataset.variantId;

    if (this.variantExists(variantId)) {
      return variantId;
    }
  }

  return '';
}

    getVariantIdFromUrl() {
      const variantId = new URLSearchParams(window.location.search).get('variant');

      if (this.variantExists(variantId)) return variantId;

      return '';
    }

    getVariantIdFromInput() {
      const scope = this.getScope();

      const inputs = Array.from(scope.querySelectorAll('form[action*="/cart/add"] [name="id"], [name="id"]'));

      const validInput = inputs.find((input) => this.variantExists(input.value));

      return validInput?.value || '';
    }

    getVariantIdFromData() {
      const scope = this.getScope();

      const elements = Array.from(scope.querySelectorAll('[data-variant-id]'));

      const validElement = elements.find((element) => {
        return this.variantExists(element.dataset.variantId);
      });

      return validElement?.dataset.variantId || '';
    }

    getVariantFromSelectedOptions() {
      const selectedOptionGroups = this.getSelectedOptionGroups();

      if (!selectedOptionGroups.length) return null;

      return this.variants.find((variant) => {
        if (!Array.isArray(variant.options)) return false;
        if (variant.options.length !== selectedOptionGroups.length) return false;

        return variant.options.every((option, index) => {
          const selectedGroup = selectedOptionGroups[index] || [];

          return selectedGroup.some((selectedOption) => {
            return this.normalize(selectedOption) === this.normalize(option);
          });
        });
      });
    }

    getSelectedOptionGroups() {
      const scope = this.getScope();
      const optionGroups = [];

      Array.from(
        scope.querySelectorAll(
          '.variant-option__select-wrapper select, variant-selects select, variant-picker select, select[name^="options"]'
        )
      ).forEach((select) => {
        const selectedOption = select.options[select.selectedIndex];

        const values = [select.value, selectedOption?.value, selectedOption?.textContent?.trim()].filter(Boolean);

        if (values.length) {
          optionGroups.push([...new Set(values)]);
        }
      });

      const radioGroups = new Map();

      Array.from(scope.querySelectorAll('input[type="radio"][name^="options"]:checked')).forEach((input) => {
        const label = input.id ? scope.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;

        const values = [input.value, label?.textContent?.trim()].filter(Boolean);

        if (values.length) {
          radioGroups.set(input.name, [...new Set(values)]);
        }
      });

      radioGroups.forEach((values) => {
        optionGroups.push(values);
      });

      return optionGroups.slice(0, this.getOptionCount());
    }

    getOptionCount() {
      const firstVariant = this.variants[0];

      if (!Array.isArray(firstVariant?.options)) return 0;

      return firstVariant.options.length;
    }

    variantExists(value) {
      if (!value) return false;

      return this.variants.some((variant) => String(variant.id) === String(value));
    }

    normalize(value) {
      return String(value || '')
        .trim()
        .toLowerCase();
    }

    renderVariant(variantId) {
      if (!this.variantExists(variantId)) return;

      this.renderTitle();
      this.renderDescription(variantId);
      this.renderPrice(variantId);
    }

    renderTitle() {
      if (!this.titleElement) return;

      this.titleElement.hidden = false;
      this.titleElement.textContent = this.productOriginalTitle || '';
    }

    renderPrice(variantId) {
      const variant = this.variants.find(
        (item) => String(item.id) === String(variantId)
      );

      if (!variant || variant.price == null) return;

      /*
       * Refresh the price elements in case the theme replaced product HTML.
       */
      this.priceElements = Array.from(
        this.section.querySelectorAll('[data-sc-wpt-retail-price]')
      );

      this.priceElements.forEach((priceElement) => {
        const moneyFormat =
          priceElement.dataset.moneyFormat || '{{ shop.money_format | escape }}';

        priceElement.innerHTML = this.formatMoney(
          Number(variant.price),
          moneyFormat
        );

        priceElement.setAttribute(
          'data-current-variant-id',
          String(variantId)
        );
      });
    }

    formatMoney(cents, format) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, format);
      }

      const placeholderRegex = /\{\{\s*(amount(?:_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator|_with_apostrophe_separator)?)\s*\}\}/;
      const match = format.match(placeholderRegex);
      const placeholder = match ? match[1] : 'amount';

      const formatNumber = (
        value,
        decimals = 2,
        thousands = ',',
        decimal = '.'
      ) => {
        const number = (Number(value) / 100).toFixed(decimals);
        const parts = number.split('.');

        parts[0] = parts[0].replace(
          /\B(?=(\d{3})+(?!\d))/g,
          thousands
        );

        return parts[1]
          ? `${parts[0]}${decimal}${parts[1]}`
          : parts[0];
      };

      let value;

      switch (placeholder) {
        case 'amount_no_decimals':
          value = formatNumber(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatNumber(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatNumber(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatNumber(cents, 2, "'", '.');
          break;
        default:
          value = formatNumber(cents, 2);
      }

      return match ? format.replace(placeholderRegex, value) : value;
    }

    renderDescription(variantId) {
      if (!this.descriptionElement) return;

      const variant = this.variants.find((item) => String(item.id) === String(variantId));
      const template = this.querySelector(`[data-variant-description-template="${variantId}"]`);

      const html = (
        variant?.descriptionHtml ||
        variant?.description_html ||
        variant?.description ||
        template?.innerHTML ||
        ''
      ).trim();

      // Force refresh the description class every time variant changes
      this.descriptionElement.classList.remove('selected-variant-title__description');
      this.descriptionElement.innerHTML = '';
      this.descriptionElement.hidden = true;

      // Force browser reflow
      void this.descriptionElement.offsetHeight;

      this.descriptionElement.classList.add('selected-variant-title__description');
      this.descriptionElement.setAttribute('data-current-variant-id', variantId);

      if (!html) {
        this.hideDescription();
        return;
      }

      this.descriptionElement.innerHTML = html;
      this.descriptionElement.hidden = false;
    }

    hideDescription() {
      if (!this.descriptionElement) return;

      this.descriptionElement.classList.remove('selected-variant-title__description');
      this.descriptionElement.innerHTML = '';
      this.descriptionElement.hidden = true;

      void this.descriptionElement.offsetHeight;

      this.descriptionElement.classList.add('selected-variant-title__description');
    }

    hideDescription() {
      if (!this.descriptionElement) return;

      this.descriptionElement.innerHTML = '';
      this.descriptionElement.hidden = true;
    }
  }

  if (!customElements.get('variant-info-description')) {
    customElements.define('variant-info-description', VariantInfoDescription);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-moq"] && !Shopify.designMode) return;
  try {
    class VariantMoq extends HTMLElement {
    connectedCallback() {
      this.moqTextElement = this.querySelector('[data-variant-moq-text]');
      this.moqValueElement = this.querySelector('[data-variant-moq-value]');
      this.variants = this.getVariants();
      this.section = this.closest('.shopify-section') || this.closest('section') || document;

      this.handleChange = this.handleChange.bind(this);
      this.handleVariantEvent = this.handleVariantEvent.bind(this);

      document.addEventListener('change', this.handleChange);
      document.addEventListener('input', this.handleChange);

      document.addEventListener('variant:change', this.handleVariantEvent);
      document.addEventListener('variant:changed', this.handleVariantEvent);
      document.addEventListener('product:variant-change', this.handleVariantEvent);
      document.addEventListener('product:variant:change', this.handleVariantEvent);
      document.addEventListener('variant:update', this.handleVariantEvent);

      this.updateMoq();
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.handleChange);
      document.removeEventListener('input', this.handleChange);

      document.removeEventListener('variant:change', this.handleVariantEvent);
      document.removeEventListener('variant:changed', this.handleVariantEvent);
      document.removeEventListener('product:variant-change', this.handleVariantEvent);
      document.removeEventListener('product:variant:change', this.handleVariantEvent);
      document.removeEventListener('variant:update', this.handleVariantEvent);
    }

    getVariants() {
      const json = this.querySelector('[data-variant-moq-json]');

      if (!json) return [];

      try {
        return JSON.parse(json.textContent);
      } catch (error) {
        console.warn('Variant MOQ JSON parse error:', error);
        return [];
      }
    }

    handleChange(event) {
      const target = event.target;

      if (!target) return;

      const isVariantInput = target.matches(
        '.variant-option__select-wrapper select, variant-selects select, variant-picker select, select[name^="options"], input[type="radio"][name^="options"], input[name="id"], select[name="id"]'
      );

      if (!isVariantInput) return;

      const targetSection = target.closest('.shopify-section') || target.closest('section');

      if (targetSection && this.section !== document && targetSection !== this.section) {
        return;
      }

      this.scheduleUpdate();
    }

    handleVariantEvent(event) {
      const variant = event.detail?.variant || event.detail?.selectedVariant || event.detail?.resource;

      if (variant?.id && this.variantExists(variant.id)) {
        this.renderMoq(String(variant.id));
        return;
      }

      this.scheduleUpdate();
    }

    scheduleUpdate() {
      window.requestAnimationFrame(() => this.updateMoq());
      window.setTimeout(() => this.updateMoq(), 80);
      window.setTimeout(() => this.updateMoq(), 180);
      window.setTimeout(() => this.updateMoq(), 400);
    }

    updateMoq() {
      const variantId = this.getCurrentVariantId();

      if (!variantId) {
        this.hideMoq();
        return;
      }

      this.renderMoq(variantId);
    }

    getCurrentVariantId() {
      const variantIdFromSelectedOption = this.getVariantIdFromSelectedOption();

      if (variantIdFromSelectedOption) {
        return String(variantIdFromSelectedOption);
      }

      const variantFromOptions = this.getVariantFromSelectedOptions();

      if (variantFromOptions?.id) {
        return String(variantFromOptions.id);
      }

      const variantIdFromInput = this.getVariantIdFromInput();

      if (variantIdFromInput) {
        return String(variantIdFromInput);
      }

      return this.dataset.initialVariantId || '';
    }

    getVariantIdFromSelectedOption() {
      const scope = this.section || document;

      const selects = Array.from(
        scope.querySelectorAll(
          '.variant-option__select-wrapper select, variant-selects select, variant-picker select, select[name^="options"]'
        )
      );

      for (const select of selects) {
        const selectedOption = select.options[select.selectedIndex];

        if (!selectedOption) continue;

        const variantId = selectedOption.dataset.variantId;

        if (this.variantExists(variantId)) {
          return variantId;
        }
      }

      return '';
    }

    getVariantIdFromInput() {
      const scope = this.section || document;

      const input = scope.querySelector('form[action*="/cart/add"] [name="id"], [name="id"]');

      if (this.variantExists(input?.value)) {
        return input.value;
      }

      return '';
    }

    getVariantFromSelectedOptions() {
      const selectedOptionGroups = this.getSelectedOptionGroups();

      if (!selectedOptionGroups.length) return null;

      return this.variants.find((variant) => {
        if (!Array.isArray(variant.options)) return false;
        if (variant.options.length !== selectedOptionGroups.length) return false;

        return variant.options.every((option, index) => {
          const selectedGroup = selectedOptionGroups[index] || [];

          return selectedGroup.some((selectedOption) => {
            return this.normalize(selectedOption) === this.normalize(option);
          });
        });
      });
    }

    getSelectedOptionGroups() {
      const scope = this.section || document;
      const optionGroups = [];

      Array.from(
        scope.querySelectorAll(
          '.variant-option__select-wrapper select, variant-selects select, variant-picker select, select[name^="options"]'
        )
      ).forEach((select) => {
        const selectedOption = select.options[select.selectedIndex];

        const values = [
          select.value,
          selectedOption?.value,
          selectedOption?.textContent?.trim(),
        ].filter(Boolean);

        if (values.length) {
          optionGroups.push([...new Set(values)]);
        }
      });

      Array.from(scope.querySelectorAll('input[type="radio"][name^="options"]:checked')).forEach((input) => {
        const label = input.id ? scope.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;

        const values = [
          input.value,
          label?.textContent?.trim(),
        ].filter(Boolean);

        if (values.length) {
          optionGroups.push([...new Set(values)]);
        }
      });

      return optionGroups.slice(0, this.getOptionCount());
    }

    getOptionCount() {
      const firstVariant = this.variants[0];

      if (!Array.isArray(firstVariant?.options)) return 0;

      return firstVariant.options.length;
    }

    variantExists(value) {
      if (!value) return false;

      return this.variants.some((variant) => String(variant.id) === String(value));
    }

    normalize(value) {
      return String(value || '').trim().toLowerCase();
    }

    renderMoq(variantId) {
      if (!this.moqTextElement || !this.moqValueElement) return;

      const variant = this.variants.find((item) => String(item.id) === String(variantId));
      const moq = variant?.moq;

      if (moq === undefined || moq === null || String(moq).trim() === '') {
        this.hideMoq();
        return;
      }

      this.moqValueElement.textContent = moq;
      this.moqTextElement.setAttribute('data-current-variant-id', variantId);
      this.moqTextElement.hidden = false;
    }

    hideMoq() {
      if (!this.moqTextElement || !this.moqValueElement) return;

      this.moqValueElement.textContent = '';
      this.moqTextElement.hidden = true;
    }
  }

  if (!customElements.get('variant-moq')) {
    customElements.define('variant-moq', VariantMoq);
  }
  } catch(e) { console.error(e); }
})();

})();
